/**
 *
 */
export enum ListingStatus {
  AVAILABLE = 'Available',
  SOLD = 'Sold',
  UNDER_NEGOTIATION = 'UnderNegotiation',
}
